<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_cu10"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('translateinvoice_search_button')"
          @click="InvoiceInquiry()"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('translateinvoice_get_button')"
          @click="getSelectEvent()"
        >
          索取发票
        </el-button>

        <el-button
          v-if="getLimit('translateinvoice_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
        <el-button @click="columnSettingVisible = true">列设置</el-button>
        <div class="total_Amount_div">
          选中发票总金额:
          <span class="total_Amount_span">{{ totalAmount }}元</span>
        </div>
      </template>
    </vxe-toolbar>
    <vxe-table
      v-if="showTable"
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :checkbox-config="{ highlight: true }"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxAll"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column
        v-for="col in columns"
        v-if="col.visible"
        :key="col.value"
      >
        <vxe-table-column
          :field="col.value"
          :title="col.name"
          :min-width="col.minWidth || 160"
          :sortable="
            col.value === 'gmtCreated' ||
              col.value === 'lastLoadingTime' ||
              col.value === 'lastUnloadingTime' ||
              col.value === 'gmtModified'
          "
        >
          <template #default="scope">
            <div class="oeder_num_box">
              <span
                v-if="
                  scope.column.property === 'projectName' ||
                    scope.column.property === 'lineName'
                "
                class="copy_text_span"
                @click="copyText(formatterSwitch(scope))"
                v-html="formatterSwitch(scope)"
              />
              <el-tooltip
                v-else-if="scope.column.property === 'reviewMsg'"
                class="item"
                effect="dark"
                :content="scope.row.reviewMsg || '--'"
                placement="top-start"
              >
                <span
                  class="copy_text_cursor review-msg-text"
                  :class="{ 'review-msg-text--empty': !scope.row.reviewMsg }"
                  @click="copyText(scope.row.reviewMsg || '')"
                  >{{ scope.row.reviewMsg || "--" }}</span
                >
              </el-tooltip>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                :content="String(formatterSwitch(scope))"
                placement="top-start"
              >
                <span
                  class="copy_text_cursor"
                  @click="copyText(formatterSwitch(scope))"
                  >{{ formatterSwitch(scope) }}</span
                >
              </el-tooltip>
            </div>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <template
            v-if="
              col.value === 'mainOrderNumber' ||
                col.value === 'orderCode' ||
                col.value === 'sourceOrderNumber' ||
                col.value === 'projectName' ||
                col.value === 'lineName' ||
                col.value === 'driverName' ||
                col.value === 'driverPhone' ||
                col.value === 'vehicleLicense' ||
                col.value === 'shipperName' ||
                col.value === 'shipperPhone' ||
                col.value === 'placeOfShipment' ||
                col.value === 'consigneeName' ||
                col.value === 'consigneePhone' ||
                col.value === 'placeOfReceipt'
            "
          >
            <el-input
              v-model="listQuery[col.value]"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'branchCode'">
            <el-select
              v-model="listQuery.branchCode"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in branchList"
                :key="item.code"
                :label="item.groupName"
                :value="item.code"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'shipmentActualFreight'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipmentActualFreightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipmentActualFreightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'loadQuantity'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.loadQuantityStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.loadQuantityEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                /> </el-col
            ></el-row>
          </template>
          <template v-if="col.value === 'unloadQuantity'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.unloadQuantityStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.unloadQuantityEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'gmtCreated'">
            <el-date-picker
              v-model="listQuery.gmtCreatedRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
        </template>
      </vxe-table-column>
      <template v-if="false">
        <vxe-table-column>
          <vxe-table-column
            field="branchCode"
            title="承运主体"
            :formatter="formatterBranch"
            min-width="280"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.branchCode"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in branchList"
                :key="item.code"
                :label="item.groupName"
                :value="item.code"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="mainOrderNumber"
            title="货源单号"
            min-width="250"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.mainOrderNumber"
              placeholder="货源单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="orderCode"
            title="运输单号"
            min-width="250"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.orderCode"
              placeholder="运输单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 项目名称 -->
        <vxe-table-column>
          <vxe-table-column
            field="sourceOrderNumber"
            title="来源单号"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.sourceOrderNumber"
              placeholder="请输入来源单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="projectName"
            title="项目名称"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.projectName"
              placeholder="请输入项目名称"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="lineName"
            title="线路简称"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.lineName"
              placeholder="请输入线路简称"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 实际承运人姓名 -->
        <vxe-table-column>
          <vxe-table-column
            field="driverName"
            title="实际承运人姓名"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.driverName"
              placeholder="实际承运人姓名"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 实际承运人电话 -->
        <vxe-table-column>
          <vxe-table-column
            field="driverPhone"
            title="实际承运人电话"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.driverPhone"
              placeholder="实际承运人电话"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 车牌号 -->
        <vxe-table-column>
          <vxe-table-column
            field="vehicleLicense"
            title="车牌号"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.vehicleLicense"
              placeholder="车牌号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shipmentActualFreight"
            title="托运人实付运费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipmentActualFreightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipmentActualFreightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="loadQuantity"
            title="装车重量(吨)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.loadQuantityStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.loadQuantityEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="unloadQuantity"
            title="卸车重量(吨)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.unloadQuantityStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.unloadQuantityEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="shipperName"
            title="发货联系人"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.shipperName"
              placeholder="发货联系人"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shipperPhone"
            title="装货电话"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.shipperPhone"
              placeholder="装货电话"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="placeOfShipment"
            title="装货地址"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.placeOfShipment"
              placeholder="装货地址"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="consigneeName"
            title="卸货联系人"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.consigneeName"
              placeholder="卸货联系人"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="consigneePhone"
            title="收货电话"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.consigneePhone"
              placeholder="收货电话"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="placeOfReceipt"
            title="收货地址"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.placeOfReceipt"
              placeholder="收货地址"
              clearable
            />
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="gmtCreated"
            title="创建时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.gmtCreatedRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
        </vxe-table-column>
      </template>

      <vxe-table-column title="操作" fixed="right" width="50">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('translateinvoice_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="1000"
      height="600"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <vxe-modal v-model="Askfor" title="发票索取" width="1070" resize>
      <requestlist
        v-if="Askfor"
        ref="invoiceRef"
        :total-amount="+totalAmount"
        :latest-record="latestRecord"
        @event1="receive"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <el-dialog
      title="列设置"
      :visible.sync="columnSettingVisible"
      width="480px"
      custom-class="column-setting-dialog"
    >
      <ColumnDrag :columns="columns" @update="applyColumnSettings" />
    </el-dialog>
  </div>
</template>
<script>
import { translateInvoice } from "@/api/invoice";
import ColumnDrag from "@/components/ColumnDrag.vue";
import compDetail from "@/components/WaybillDetails";
import requestlist from "./components/requestlist.vue";
export default {
  name: "Parent",
  components: {
    compDetail,
    requestlist,
    ColumnDrag
  },
  data() {
    return {
      columns: [
        {
          name: "承运主体",
          value: "branchCode",
          visible: true,
          minWidth: 280
        },
        {
          name: "货源单号",
          value: "mainOrderNumber",
          visible: true,
          minWidth: 250
        },
        {
          name: "运输单号",
          value: "orderCode",
          visible: true,
          minWidth: 250
        },
        {
          name: "异常原因",
          value: "reviewMsg",
          visible: true,
          minWidth: 200
        },
        {
          name: "来源单号",
          value: "sourceOrderNumber",
          visible: true,
          minWidth: 200
        },
        {
          name: "项目名称",
          value: "projectName",
          visible: true,
          minWidth: 200
        },
        {
          name: "线路简称",
          value: "lineName",
          visible: true,
          minWidth: 200
        },
        {
          name: "实际承运人姓名",
          value: "driverName",
          visible: true,
          minWidth: 200
        },
        {
          name: "实际承运人电话",
          value: "driverPhone",
          visible: true,
          minWidth: 200
        },
        {
          name: "车牌号",
          value: "vehicleLicense",
          visible: true,
          minWidth: 200
        },
        {
          name: "托运人实付运费(元)",
          value: "shipmentActualFreight",
          visible: true,
          minWidth: 200
        },
        {
          name: "装车重量(吨)",
          value: "loadQuantity",
          visible: true,
          minWidth: 200
        },
        {
          name: "卸车重量(吨)",
          value: "unloadQuantity",
          visible: true,
          minWidth: 200
        },
        {
          name: "发货联系人",
          value: "shipperName",
          visible: true,
          minWidth: 130
        },
        {
          name: "装货电话",
          value: "shipperPhone",
          visible: true,
          minWidth: 130
        },
        {
          name: "装货地址",
          value: "placeOfShipment",
          visible: true,
          minWidth: 200
        },
        {
          name: "卸货联系人",
          value: "consigneeName",
          visible: true,
          minWidth: 130
        },
        {
          name: "收货电话",
          value: "consigneePhone",
          visible: true,
          minWidth: 130
        },
        {
          name: "收货地址",
          value: "placeOfReceipt",
          visible: true,
          minWidth: 200
        },
        {
          name: "创建时间",
          value: "gmtCreated",
          visible: true,
          minWidth: 420
        }
      ],
      showTable: true,
      columnSettingVisible: false,
      exportObj: {
        exportUrl: "/ntocc-basic-api/invoice/exportTranslateInvoice", //导出接口
        name: "发票索取"
      },
      loading: false,
      Askfor: false,
      tableData: [],
      modelDetailFlag: false,
      listQuery: {
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        billingType: ""
      },
      statusOptions: [
        { label: "申请开票", value: 0 },
        { label: "已取消", value: 1 },
        { label: "已开票", value: 2 }
      ],
      billingTypeOptions: [
        { label: "现付开票", value: 0 },
        { label: "到付开票", value: 1 },
        { label: "代付开票", value: 2 }
      ],
      codes: [],
      code: "",
      type2: [],
      types: {
        type: ""
      },
      Pagingconf: [],
      totalAmount: 0, //发票总金额
      latestRecord: {}
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  created() {
    this.findList();
    const invoiceListColumn = localStorage.getItem("invoiceListColumn");
    if (invoiceListColumn) {
      this.columns = JSON.parse(invoiceListColumn);
      if (!this.columns.some(col => col.name === "异常原因")) {
        const orderCodeIndex = this.columns.findIndex(
          col => col.name === "运输单号"
        );
        const reviewMsgCol = {
          name: "异常原因",
          value: "reviewMsg",
          visible: true,
          minWidth: 200
        };
        if (orderCodeIndex !== -1) {
          this.columns.splice(orderCodeIndex + 1, 0, reviewMsgCol);
        } else {
          this.columns.push(reviewMsgCol);
        }
      }
    }
  },
  methods: {
    copyText(text) {
      if (!text) return;
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message({
        message: "复制成功",
        type: "success",
        duration: 1500
      });
    },
    formatterSwitch(scope) {
      // console.log("格式处理=========", cell);
      // 实际承运人净得判断 未签收：deliveryFeeDeserved  已签收：deliveryFeePractical
      let valueCell = scope.row[scope.column.property];
      if (scope.column.property === "shipmentDeliveryFeePractical") {
        return scope.row.shipmentDeliveryFeePractical || scope.row.taxFee;
      }
      if (scope.column.property === "deliveryFeePractical") {
        return scope.row.deliveryFeePractical || scope.row.deliveryFeeDeserved;
        // return scope.row.isUnloadingConfirm === 0
        //   ? scope.row.deliveryFeeDeserved
        //   : scope.row.deliveryFeePractical; // cell.cellValue || 0;
      }
      if (scope.column.property === "branchCode") {
        const item = this.branchList.find(item => item.code === valueCell);
        return item ? item.groupName : "";
      }
      if (scope.column.property === "isCancel") {
        const item = this.cancelOptions.find(item => item.value === valueCell);
        return item ? item.label : "";
      }
      if (scope.column.property === "isMonthlyOrder") {
        // this.formatterField(valueCell, "isMonthlyOrder");
        const item = this.parentData[`isMonthlyOrderOptions`].find(
          item => item.value === valueCell
        );
        return item ? item.label : "";
      }
      if (scope.column.property === "isTransfer") {
        return valueCell > 0 ? "是" : "否";
      }
      if (scope.column.property === "status") {
        const item = this.statusOptions.find(
          item1 => item1.value === valueCell
        );
        return item ? item.label : "";
      }

      if (scope.column.property === "isUnloadingConfirm") {
        let data = valueCell == 0;
        return data ? "未签收" : "已签收";
      }

      if (scope.column.property === "payStatus") {
        const item = this.payOptions.find(item => item.value === valueCell);
        return item ? item.label : "";
      }

      if (scope.column.property === "isMonthlyOrder") {
        // this.formatterField(valueCell, "isMonthlyOrder");
        const item = this.parentData[`isMonthlyOrderOptions`].find(
          item => item.value === valueCell
        );
        return item ? item.label : "";
      }
      if (scope.column.property === "reportMark") {
        return valueCell > 0 ? "是" : "否";
      }
      if (scope.column.property === "prePay") {
        return Number(valueCell);
      }
      return valueCell;
    },
    applyColumnSettings(payload) {
      console.log("更新返回===========", payload);
      this.columns = payload.columns;
      localStorage.setItem(
        "invoiceListColumn",
        JSON.stringify(payload.columns)
      );
      this.columnSettingVisible = false;
      this.showTable = false;
      this.$nextTick(() => {
        this.showTable = true;
      });
      this.$forceUpdate();
    },
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        translateInvoice(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          response.data.total > 10000
            ? (this.Pagingconf = [20, 30, 50, 100, 500, 10000])
            : (this.Pagingconf = [
                20,
                30,
                50,
                100,
                500,
                response.data.total || 1
              ]);
          this.loading = false;
          resolve();
        });
      });
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.Getdetails(code);
      this.modelDetailFlag = true;
    },

    // 代发托运人子组件向父组件传值
    receive() {
      this.Askfor = false;
      this.findList();
    },
    // 状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterBillingType({ cellValue }) {
      const item = this.billingTypeOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    checkBranchCodeUniformity(arr) {
      // 空数组或单元素数组默认返回 true
      if (arr.length <= 1) return true;
      // 取第一个元素的 branchCode 作为基准值
      const firstCode = arr[0].branchCode;
      // 检查后续所有元素是否与基准值一致
      return arr.every(item => item.branchCode === firstCode);
    },
    // 索取方法
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      console.log("获取=======", selectRecords);
      if (selectRecords.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
        return false;
      }
      if (selectRecords.length > 500) {
        this.$message({
          message: "申请失败，发票索取最多支持500笔订单！",
          type: "warning"
        });
        return false;
      }
      let isSame = this.checkBranchCodeUniformity(selectRecords);
      if (!isSame) {
        this.$message({
          message: "申请失败，发票索取只支持同一承运主体的多笔订单！",
          type: "warning"
        });
        return;
      }
      const types = selectRecords.map(item => item.billingType);
      const codesArr = selectRecords.map(item => item.code);
      let repeat = false;
      types.forEach(str => {
        if (str !== types[0]) repeat = true;
      });
      if (repeat) {
        this.$message({
          message: "只能选择同一种开票方式的运单！",
          type: "warning"
        });
      } else {
        const codes = codesArr.join(",");
        //this.$refs.xTable.clearCheckboxRow()
        this.Askfor = true;
        this.$nextTick(() => {
          this.$refs.invoiceRef.invoicelist({ type: types[0] }, codes);
        });
      }
    },
    InvoiceInquiry() {
      this.loading = true;
      translateInvoice(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        this.loading = false;
      });
    },
    // 公共取消
    fatherCancel(modelFlag) {
      if (modelFlag == "detail") {
        this.modelDetailFlag = false;
      }
    },
    checkboxChange() {
      const selection = this.$refs.xTable.getSelectRecords();
      this.latestRecord = selection.sort(
        (a, b) => new Date(b.gmtCreated) - new Date(a.gmtCreated)
      )[0];
      this.totalAmount = selection
        .reduce((sum, row) => sum + (Number(row.allotTaxAmount) || 0), 0)
        .toFixed(2);
    },
    checkboxAll() {
      const selection = this.$refs.xTable.getSelectRecords();
      this.latestRecord = selection.sort(
        (a, b) => new Date(b.gmtCreated) - new Date(a.gmtCreated)
      )[0];
      console.log("时间最新===", this.latestRecord);
      console.log("选中======", selection);
      this.totalAmount = selection
        .reduce((sum, row) => sum + (Number(row.allotTaxAmount) || 0), 0)
        .toFixed(2);
    }
  }
};
</script>

<style scoped>
.total_Amount_div {
  position: absolute;
  right: 120px;
  top: 10px;
  font-weight: bold;
  font-size: 17px;
}
.total_Amount_span {
  color: #d01415;
}
.review-msg-text {
  color: red;
}
.review-msg-text--empty {
  color: #909399;
}
</style>
